/*
 * @Author: Code-HHX
 * @Date: 2022-03-24 10:35:21
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-03-24 14:32:21
 * @Description: api 统一出口
 */

import {requestGet, requestGetForm, requestPost, requestPostForm} from "../config/http-json"
import {apiPath} from "@/util/utils";

const auth = {
  async sendLiberSmsCode(params) {
    const resp = await requestPost(`/front/${apiPath}/sendLiberSmsCode`, params);
    return resp.data
  },
  async login(params) {
    const resp = await requestPost(`/front/${apiPath}/liberDoLogin`, params);
    return resp.data
  },
};

export default auth;
